"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment, ReactNode } from "react";
import { cx } from "@/lib/tailwind-utils";
import { PublicServiceDetail } from "@/types/service";
import { EmptyServicesState } from "./empty-services-state";
import { PriceDisclaimer } from "./price-disclaimer";
interface FlatServicesMenuProps {
  services: PublicServiceDetail[];
  renderService: (service: PublicServiceDetail, index: number, animationDelay: number) => ReactNode;
  className?: string;
}

/** Shared flat presentation; callers retain their selection/verification rules. */
export const FlatServicesMenu = t0 => {
  const $ = _c(11);
  const {
    services,
    renderService,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("mt-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== renderService || $[3] !== services) {
    t2 = services.length === 0 ? <EmptyServicesState /> : <div className="group/list bg-background rounded-xl border border-border/60 shadow-sm">{services.map((service, index) => <Fragment key={service.id}>{renderService(service, index, 250 / services.length * index)}</Fragment>)}</div>;
    $[2] = renderService;
    $[3] = services;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== services) {
    t3 = services.some(_temp) && <PriceDisclaimer />;
    $[5] = services;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(service_0) {
  return service_0.estimated;
}